import axiosClient from "utils/api";
const URI = "/admin/setting";

export const getAllSettings = async () => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get setting:", error);
    throw error;
  }
};

export const updateSettings = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during update setting:", error);
    throw error;
  }
};

export const getDefaultPreferences = async () => {
  const URL = `${URI}/preferences`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get preferences:", error);
    throw error;
  }
};

export const updateDefaultPreferences = async (payload) => {
  const URL = `${URI}/preferences`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during update preferences:", error);
    throw error;
  }
};

// get maintenance
export const getAllMaintenance = async (payload) => {
  const URL = `${URI}/maintenance`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get maintenance:", error);
    throw error;
  }
};

// add maintenance
export const addMaintenance = async (payload) => {
  const URL = `${URI}/maintenance`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during add maintenance:", error);
    throw error;
  }
};

// update maintenance
export const updateMaintenance = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/maintenance/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during update maintenance:", error);
    throw error;
  }
};

// delete maintenance
export const deleteMaintenance = async (payload) => {
  const URL = `${URI}/maintenance/${payload?.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during delete maintenance:", error);
    throw error;
  }
};

// archive maintenance
export const archiveMaintenance = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/maintenance/${id}/archive`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during archive maintenance:", error);
    throw error;
  }
};
  
